import { render, staticRenderFns } from "./SimpleItemTSCard.vue?vue&type=template&id=8f0399fc&scoped=true&"
import script from "./SimpleItemTSCard.vue?vue&type=script&lang=js&"
export * from "./SimpleItemTSCard.vue?vue&type=script&lang=js&"
import style0 from "./SimpleItemTSCard.vue?vue&type=style&index=0&id=8f0399fc&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f0399fc",
  null
  
)

export default component.exports